<template>
  <q-tooltip
    :anchor="anchor"
    :content-class="tooltipClasses"
    :offset="offset"
    :self="self"
    :transition-hide="transitionHide"
    :transition-show="transitionShow"
    ><slot
  /></q-tooltip>
</template>

<script setup lang="ts">
import type { QTooltipProps } from 'quasar';
import { computed } from 'vue';

defineOptions({ name: 'ToolTip' });

const props = withDefaults(
  defineProps<{
    anchor?: QTooltipProps['anchor'];
    contentClass?: string;
    dark?: boolean;
    noBorder?: boolean;
    offset?: [number, number];
    self?: QTooltipProps['self'];
    transitionHide?: string;
    transitionShow?: string;
  }>(),
  {
    anchor: 'top middle',
    self: 'bottom middle',
    offset: () => [0, 0],
    transitionHide: 'jump-down',
    transitionShow: 'jump-up',
  }
);

const tooltipClasses = computed(() => {
  const classes = [];

  if (props.dark) {
    classes.push('tooltip--dark text-white');
  } else {
    classes.push('text-black bg-silver');
  }

  if (!props.noBorder) {
    classes.push('tooltip-border');
  }

  if (props.contentClass) {
    classes.push(props.contentClass);
  }

  return classes.join(' ');
});
</script>

<style lang="scss" scoped>
.tooltip-border {
  border: 1px solid #d3d3d3;
}

.tooltip--dark {
  background: #757575;
}
</style>
